import React, { useEffect, useCallback } from "react"
import VideoPlayer from "./VideoPlayer.js"

export const Incorrect = ({
  categoryId,
  selectedClueIndex,
  openCategoryModal,
  selectedOption,
  categories1,
  shuffledOptions,
}) => {
  const answer = categories1[selectedClueIndex].answer

  const normalize = (s) => s.replace(/\s+/g, " ").trim()

  // Check if this option is a correct answer
  const isCorrectAnswer = (option) => {
    const normOption = normalize(option)
    return answer.some((a) => {
      const normA = normalize(a)
      return normOption === normA || normOption.startsWith(normA)
    })
  }

  // Check if user selected this option
  const wasSelectedByUser = (option) => {
    return selectedOption.includes(option)
  }

  // Get label class based on whether it's correct or user selected it incorrectly
  const getLabelClass = (option) => {
    if (isCorrectAnswer(option)) {
      return "answerForIncorrect"
    }
    if (wasSelectedByUser(option) && !isCorrectAnswer(option)) {
      return "incorrectAnswer"
    }
    return ""
  }

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Escape") {
        openCategoryModal()
      }
    },
    [openCategoryModal],
  )

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown)
    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [handleKeyDown])

  return (
    <>
      <div className="categoryOverlay"></div>

      <div
        className="categoryModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="incorrect-header"
      >
        <div className="closeButtonContainer">
          <button
            className="modalButton"
            onClick={openCategoryModal}
            aria-label="Close modal"
          >
            X
          </button>
        </div>
        <h1 id="incorrect-header" className="incorrectHeader">
          Incorrect.
        </h1>
        <div className="question">
          <p className="questionP">
            {categories1[selectedClueIndex].question}
          </p>
        </div>

        <div className="category" data-testid="category">
          <form>
            {shuffledOptions.map((option, index) => (
              <div className="formContainer" key={index}>
                <input
                  className="radioButton"
                  type={answer.length > 1 ? "checkbox" : "radio"}
                  id={`option${index + 1}`}
                  name="picklist"
                  value={option}
                  checked={wasSelectedByUser(option)}
                  disabled
                  readOnly
                />
                <label className={getLabelClass(option)}>
                  {option}
                </label>
              </div>
            ))}
            <div className="explanationContainer">
              <span>Explanation:</span>
              <p className="explanation">
                {categories1[selectedClueIndex].explanation}
              </p>
            </div>
            <VideoPlayer
              videoUrl={categories1[selectedClueIndex].video_url}
              videoTitle={categories1[selectedClueIndex].video_title}
            />
          </form>
        </div>
      </div>
    </>
  )
}
